<div class="min-h-dvh d-flex align-items-center justify-content-center px-3 py-4">
    @if (!store.brandingResolved()) {
        <!--
            Held back until branding resolves so the customer never sees the page repaint from the
            default palette into their retailer's. The spinner is deliberately neutral: anything
            themed would itself flash colour, which is the problem being avoided.
        -->
        <div class="spinner-border text-body-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    } @else {
    <div class="card shadow-sm w-100 max-w-md">
        <div class="card-body p-4">
            <div class="text-center mb-4">
                @if (currentLogoUrl()) {
                    <img id="header-logo" [src]="currentLogoUrl()" alt="" class="img-fluid max-h-12 mb-3" />
                }
                <h1 class="h5 fw-bold mb-0">Your inspection report</h1>
            </div>

            @if (isRegistrationChallenge()) {
                <p class="text-body-secondary small mb-4">Enter your vehicle's registration to view it.</p>

                <form [formGroup]="registrationFormGroup" (ngSubmit)="onSubmitRegistration()">
                    <label for="registration" class="form-label fw-semibold">Vehicle registration</label>
                    <input
                        type="text"
                        class="form-control form-control-lg uppercase placeholder:normal-case"
                        id="registration"
                        formControlName="registration"
                        placeholder="e.g. 1AB2CD"
                        autocomplete="off"
                        autocapitalize="characters"
                        autocorrect="off"
                        spellcheck="false"
                        enterkeyhint="go"
                    />
                    <button type="submit" [disabled]="!registrationFormGroup.valid" class="btn btn-primary btn-lg w-100 mt-3">
                        View Report
                    </button>
                </form>
            } @else {
                <p class="text-body-secondary small mb-4">Enter the verification code sent to your email or phone.</p>

                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                    <label for="code" class="form-label fw-semibold">Verification code</label>
                    <input
                        type="text"
                        class="form-control form-control-lg"
                        id="code"
                        formControlName="code"
                        placeholder="Enter verification code"
                        autocomplete="one-time-code"
                        inputmode="numeric"
                        enterkeyhint="go"
                    />
                    <button type="submit" [disabled]="!formGroup.valid" class="btn btn-primary btn-lg w-100 mt-3">Verify</button>
                </form>
            }
        </div>
    </div>
    }
</div>
